export default class BOVariantStockModel {
  constructor() {
    this.Purchasable= false;
      
    this.PurchasableLabel = '';
  
    this.PurchasableLimit = 0;
  
    this.StockQuantity = 0;
  
    this.StockStatus = {
      Value: 0,
      Name: 'OutOfStock'
    };

    this.LimitStockQuantity = '';

    this.BOPISThreshold = 0;
  }
  getData(dataSource, backOrderLabel, preOrderLabel, instockLabel, outStockLabel) {
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'Purchasable')) {
      this.Purchasable = dataSource.Purchasable ? dataSource.Purchasable : this.Purchasable;
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'PurchasableLabel')) {
      this.PurchasableLabel = dataSource.PurchasableLabel ? dataSource.PurchasableLabel : this.PurchasableLabel;
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'PurchasableLimit')) {
      this.PurchasableLimit = dataSource.PurchasableLimit ? dataSource.PurchasableLimit : this.PurchasableLimit;
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'StockQuantity')) {
      this.StockQuantity = dataSource.StockQuantity ? dataSource.StockQuantity : this.StockQuantity;
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'StockStatus')) {
      this.StockStatus = dataSource.StockStatus ? dataSource.StockStatus : this.StockStatus;

      this.FinalStatus = renderDeliveryLabel(this.StockStatus.Name, backOrderLabel, preOrderLabel, instockLabel, outStockLabel);
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'LimitStockQuantity')) {
      this.LimitStockQuantity = dataSource.LimitStockQuantity;
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'BOPISThreshold')) {
      this.BOPISThreshold = dataSource.BOPISThreshold;
    }

    return this;
  }
}
  
export const renderDeliveryLabel = (Type, backOrderLabel, preOrderLabel, instockLabel, outStockLabel) => {

  const listLabel = {
    'InStock': instockLabel,
    'PreOrderable': preOrderLabel,
    'BackOrderable': backOrderLabel,
    'OutOfStock' : outStockLabel,
  };

  const listAvaiable = {
    'InStock': true,
    'PreOrderable': true,
    'BackOrderable': true,
    'OutOfStock' : false,
  };

  return { 
    DeliveryLabel: listLabel[Type],
    isAvaiable: listAvaiable[Type],
  };
};
  